import React, { useEffect, useState } from 'react'
import className from 'classnames/bind'
import { isEmpty } from 'lodash'
import { useHistory } from 'react-router'

import style from './MyhouseMainNoticePage.module.scss'

import MyhouseMainNoticeList from '@Components/modules/MyhouseMainNoticeList'
import IconWrite from '@Ui/images/myhouse/IconWrite.svg'
import SVG_MyhouseMainNoticeMore from '@Ui/images/myhouse/myhouse_main_notice--more.svg'
import useMain from '@Hooks/myhouse/main/useMain'
import useNotice from '@Hooks/myhouse/notice/useNotice'
import SvgMyhouseMainNoticeEmpty from '@Ui/images/myhouse/myhouse_main_notice--empty.svg'
import IconCloseTooltip from '@Root/ui/images/myhouse/IconCloseTooltip.svg'
import ArrowTooltip from '@Root/ui/images/myhouse/ArrowTooltip.svg'
import { MY_HOUSE_AUTH_STATUS, MY_HOUSE_NOTICE_CATEGORY } from '@Root/contants/myhouse'
import { LAND_SERVICE_PREFIX_URL } from '@Root/contants/urlConstants'
import { FETCH_STATUS } from '@Root/contants'
import { MODAL_TYPE } from '@Root/contants/myhouseModal'
import useBoard from '@Hooks/myhouse/board/useBoard'
import useModal from '@Hooks/myhouse/useModal'
import { handleNclickMix } from '@Helpers/nclick'
import { NCLICK } from '@Root/contants/lcs'

const cx = className.bind(style)

const MyhouseMainNoticePage: React.FC = () => {
  //변수선언부
  const { reduxMain, refreshMasonryGrid } = useMain()
  const { house } = reduxMain
  const complexNo = house?.complexNo || 0
  const { loadInitialNoticeList, notice } = useNotice()
  const { noticeList } = notice
  const defaultNoticeList = noticeList[MY_HOUSE_NOTICE_CATEGORY.ALL]
  const fetchStatus = noticeList.fetchStatus
  const { getAuthStatusForBoard } = useBoard()
  const { open } = useModal()

  const history = useHistory()

  const noticeIsEmpty = isEmpty(defaultNoticeList)
  const [isTooltip, setIsTooltip] = useState((localStorage.getItem('myhouse:main:notice:tooltip:close') || 'N') === 'N')

  //함수정의부
  const clickUploadNotice = (event: React.SyntheticEvent) => {
    event.preventDefault()
    event.stopPropagation()

    if (getAuthStatusForBoard() === MY_HOUSE_AUTH_STATUS.COMPLETE) {
      history.push(`${LAND_SERVICE_PREFIX_URL.MYHOUSE_COMPLEXES}/${complexNo}/board/form/notices`)
      return
    } else if (getAuthStatusForBoard() === MY_HOUSE_AUTH_STATUS.PROGRESS) {
      open(MODAL_TYPE.AUTH_NOT_COMPLETED)
      return
    } else {
      open(MODAL_TYPE.MYHOUSE_AUTHENTICATION_REQUIRED, { myhouseNo: house?.houseNo })
    }
  }

  const clickMoreNotice = (event: React.SyntheticEvent) => {
    event.preventDefault()
    event.stopPropagation()

    history.push(`${LAND_SERVICE_PREFIX_URL.MYHOUSE_COMPLEXES}/${complexNo}/notices`)
  }

  const handleCloseTooltip = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
    event.stopPropagation()
    setIsTooltip(false)

    localStorage.setItem('myhouse:main:notice:tooltip:close', 'Y')
  }

  //useEffect
  useEffect(() => {
    if (complexNo) {
      loadInitialNoticeList({
        complexNo,
        offset: 0,
        limit: 4,
      })
    }
  }, [complexNo])

  useEffect(() => {
    if (fetchStatus === FETCH_STATUS.SUCCESS) {
      refreshMasonryGrid()
    }
  }, [fetchStatus])

  if (fetchStatus === FETCH_STATUS.INITIAL || fetchStatus === FETCH_STATUS.PENDING || !complexNo) {
    return <></>
  }

  return (
    <>
      <div className={cx('article')}>
        {noticeIsEmpty ? (
          <>
            <div className={cx('header')}>
              <h2 className={cx('title')}>공지사항</h2>
            </div>
            <div className={cx('img_empty')}>
              <SvgMyhouseMainNoticeEmpty />
            </div>
            <p className={cx('empty_text')}>
              엘리베이터 또는 게시판에 부착된 공지사항을
              <br />
              휴대폰으로 찍어서 올려보세요.
              <br />
              간편하게 이웃들과 소식을 공유할 수 있어요!
            </p>
            <a href="#" onClick={handleNclickMix(NCLICK.MY_HOUSE.MAIN_NOTICE.EMPTY_NOTICE_ENROL, clickUploadNotice)} className={cx('link_enrol')}>
              공지사항 등록하기
            </a>
          </>
        ) : (
          <>
            <div className={cx('header')}>
              <h2 className={cx('title')}>공지사항</h2>
              <button type="button" onClick={handleNclickMix(NCLICK.MY_HOUSE.MAIN_NOTICE.ENROL, clickUploadNotice)} className={cx('button_enrol')}>
                <IconWrite />
                등록하기
              </button>
              {isTooltip && (
                <span className={cx('layer')}>
                  공지사항을 사진으로 찍어서 올려보세요!
                  <button type="button" id={'main_notice_close_button'} className={cx('button_close')} onClick={(e) => handleCloseTooltip(e)}>
                    <IconCloseTooltip />
                    <span className="blind">닫기</span>
                  </button>
                  <ArrowTooltip />
                </span>
              )}
            </div>
            <MyhouseMainNoticeList list={defaultNoticeList} complexNo={complexNo} />
            <a href="#" onClick={handleNclickMix(NCLICK.MY_HOUSE.MAIN_NOTICE.MORE, clickMoreNotice)} className={cx('link_more')}>
              <span className={cx('title')}>공지사항 더보기</span>
              <SVG_MyhouseMainNoticeMore />
            </a>
          </>
        )}
      </div>
    </>
  )
}

export default MyhouseMainNoticePage
